import React, { Component } from 'react'
import './css.css';


class Bows extends Component {
   
    render(){
        console.log(this.props.update) 
        return ( 
            <div>
                <div id="bows_flyer" className="text white">
                    <div id="bows_mainlabel">🌈 BOWS</div>
                    <div id="bows_sublabel">Bows Distribution/Work Logic</div>
                    <div className="bows_panel dark darkblue text white">
                        <div className="instructions_title light lightblue text white">💦 DISTRIBUTION</div>
                        <br></br><br></br>
                        Bows tokens are the equities of the Org.
                        <br></br>
                        <br></br>
                        1M Bows max supply.
                        <br></br>
                        <br></br>
                        15k Bows to DFOHUB.
                        <br></br>
                        <br></br>
                        HappyFarm Beans holders will get 100 Bows for each Bean (early Nov 2020).
                        <br></br>
                        <br></br>
                        Remaining Beans: 
                        <br></br>
                        <br></br>
                        30% to HappyFarm<br></br>(HappyFarm will keep them forever in order to claim its income from SmartShop)
                        <br></br>
                        <br></br>
                        10% distributed to Beans holders in 3 further cycles<br></br>(1 month later each - HappFarm Master is excluded by these cycles)
                        <br></br>
                        <br></br>
                        30% distributed via the new liquidity mining and hackathons<br></br>(percentages to be discussed)<br></br>in order to promote the creation of modules.
                        <br></br>
                        <br></br>
                        30% slow fair inflation
                        <br></br><br></br><br></br>
                        <div  className="instructions_title light lightblue">🤹 LOGIC</div>
                        <br></br><br></br>
                        If you own Bows you own part of the Organization.<br></br>
                        Bows holders must vote to accept new smart_modules for the shops.<br></br>
                        Bows holders must vote to define how the shop income is distributed among:<br></br><br></br>
                        <i>
                        Development (Incentives - Outsourcing - Hiring)<br></br>
                        Promotion (Hackathons)<br></br>
                        Bows holders<br></br>
                        Referrals<br></br>
                        </i>
                    </div>
                </div>
            </div>
        );
    }


}




export default Bows